<template>


  <div class="user-agreement">
    <h1>退款说明</h1>
    <p>
    Q: 支持退款吗?<br/>
A: 若您支付后未申请下载高清图片原件， 7个工作日内可支持退款。
    </p>
    <p>
      Q: 购买后有哪些合法使用保障？<br/>  
A: PicoPi.cn可交易的全部内容均为正版动漫作品。当您购买授权后，我们可以为您提供发票、授权书以及协议，上述任意凭证均可直接说明您的作品来源。
    </p>
    <p>
      Q: 支持开发票吗？<br/>
A: 可以提供发票，个人账号提供增值税电子普通发票，企业账号提供增值税电子普通/增值税专用发票 （港、澳、台地区除外）
您下单支付成功后，向help@picopi.cn发邮件申请发票即可；
增值税电子普通发票24小时发送到邮箱，增值税专用发票7-30天内发送到邮箱。
    </p>
  </div>
</template>

<script>
export default {
  name: "goodsauth",
};
</script>

<style scoped lang='less'>
.user-agreement {
  font-family: Arial, sans-serif;
  color: black;
   width: 90%;
  height: 100%;
  padding: 100px 20px;
}

.user-agreement h1,
.user-agreement h2,
.user-agreement h3 {
  color: black;
  margin-top: 15px;
  text-align: center;
    font-weight: bold;
    font-size: 30px;
}

.user-agreement p {
  color: black;
  margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/refund.vue